import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import { BsPencil } from 'react-icons/bs';
import { MdLockReset } from "react-icons/md";
import { DateFormat, DateTimeFormat } from '../utils/DateFormat';

const CommonTable = ({
  loading,
  rows,
  columns,
  onSelectAllChange,
  selectedRows,
  onCheckboxChange,
  setSelectedRows,
  handleShowAssignModal,
  handleEditClick,
  basePath,
  showLimitedOptions,
  showCheckboxes = true,
  showActions = true,
  handleShowViewModal,
  handleShowStatusModal,
  offset = 0,
  handleShowResetPasswordModal,
  getStatusBadgeClass = () => 'bg-transparent',
}) => {
  const renderTags = (tags) => {
    try {
      const parsedTags = JSON.parse(tags);
      return Array.isArray(parsedTags) ? parsedTags.join(', ') : tags;
    } catch {
      return tags;
    }
  };

  const formatStatus = (status) =>
    status
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const renderStatus = (row) => {
    const statusClass = getStatusBadgeClass(row.status);
    const statusText = formatStatus(row.status);

    return statusClass === 'bg-transparent' ? (
      <span>{statusText}</span>
    ) : (
      <span
        className={statusClass}
        onClick={(e) => {
          e.preventDefault();
          handleShowStatusModal?.(row.id);
        }}
      >
        {statusText}
      </span>
    );
  };

  const renderAssign = (row) => {
    const assignedUser = row.assignedTo?.name || 'Unassigned';
    return (
      <span
        className={`badge ${row.assignedTo ? 'bg-success' : 'bg-danger'}`}
        onClick={(e) => {
          e.preventDefault();
          handleShowAssignModal?.([row.id]);
        }}
      >
        {assignedUser}
      </span>
    );
  };

  // Handles nested accessors like 'user.name'
  const getCellValue = (row, accessor) => {
    const value = accessor.split('.').reduce((obj, key) => obj?.[key], row);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (value === null || value === undefined) return 'N/A';
    return value;
  };

  return (
    <div className="table-responsive">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <table className="table table-hover table-sm table-nowrap card-table">
          <thead>
            <tr>
              {showCheckboxes && (
                <th scope="col">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={
                        Array.isArray(selectedRows) &&
                        selectedRows.length === rows.length &&
                        rows.length > 0
                      }
                      onChange={onSelectAllChange}
                      disabled={rows.length === 0}
                    />
                  </div>
                </th>
              )}
              {showActions && <th scope="col" />}
              {columns
                .filter((col) => col.accessor !== '')
                .map((column) => (
                  <th key={column.accessor} scope="col">
                    {column.Header}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="list fs-base">
            {rows.map((row, index) => (
              <tr key={row.id}>
                {showCheckboxes && (
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input list-checkbox"
                        id={`listCheckbox${row.id}`}
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => onCheckboxChange(row.id)}
                      />
                    </div>
                  </td>
                )}

                {showActions && (
                  <td className="text-end">
                    <div className="dropdown profiling-dropdown">
                      <NavLink
                        className="dropdown-ellipses dropdown-toggle"
                        to="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="fe fe-more-vertical" />
                      </NavLink>
                      <div className="dropdown-menu dropdown-menu-end custom-dropdown">
                        {!showLimitedOptions && (
                          <>
                            <NavLink to={`/${basePath}/${row.id}`} className="dropdown-item">
                              View
                            </NavLink>
                            <NavLink
                              to="#"
                              className="dropdown-item"
                              onClick={(e) => {
                                e.preventDefault();
                                handleShowAssignModal?.([row.id]);
                              }}
                            >
                              Assign
                            </NavLink>
                          </>
                        )}
                        <NavLink
                          to={basePath === 'role' ? '#' : `/${basePath}/${row.id}/edit/`}
                          className="dropdown-item"
                          onClick={(e) => {
                            if (basePath === 'role') {
                              e.preventDefault();
                              handleEditClick?.(row);
                            }
                          }}
                        >
                          Edit
                        </NavLink>
                      </div>
                    </div>
                  </td>
                )}

                {columns
                  .filter((col) => col.accessor !== '')
                  .map((column) => (
                    <td key={column.accessor}>
                      {(() => {
                        switch (column.accessor) {
                          case 'data':
                            return (
                              <NavLink
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleShowViewModal(row.id);
                                }}
                              >
                                <FaEye />
                              </NavLink>
                            );
                          case 'action':
                            return (
                              <NavLink
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditClick?.(row);
                                }}
                              >
                                <FaEye />
                              </NavLink>
                            );
                          case 'action1':
                            return (
                              <NavLink
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditClick?.(row);
                                }}
                              >
                                <BsPencil />
                              </NavLink>
                            );
                          case 'change_password':
                            return (
                              <NavLink
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleShowResetPasswordModal?.(row.id);
                                }}
                              >
                                <MdLockReset style={{ marginLeft: '45px' }} size={25} />
                              </NavLink>
                            ); case 'id':
                            return <span>{offset + index + 1}</span>;
                          case 'start_date':
                          case 'due_date':
                          case 'expiry_date':
                            return <span>{DateFormat(row[column.accessor]) || 'N/A'}</span>;
                          case 'createdAt':
                            return <span>{DateTimeFormat(row[column.accessor]) || 'N/A'}</span>;
                          case 'name':
                            return (
                              <NavLink to={`/${basePath}/${row.id}/edit`}>
                                {row[column.accessor] ?? 'N/A'}
                              </NavLink>
                            );
                          case 'role_name':
                            return <span>{row.name ?? 'N/A'}</span>;
                          case 'company':
                          case 'company.name':
                            return (
                              <NavLink to={`/${basePath}/${row.id}`}>
                                <span>{row.company?.name || row.company || 'N/A'}</span>
                              </NavLink>
                            );
                          case 'subject':
                            return !showLimitedOptions ? (
                              <NavLink to={`/${basePath}/${row.id}`}>
                                {row[column.accessor] ?? 'N/A'}
                              </NavLink>
                            ) : (
                              <span>{row[column.accessor] ?? 'N/A'}</span>
                            );
                          case 'createdBy':
                            return <span>{row.createdBy?.name ?? 'N/A'}</span>;
                          case 'assignedTo':
                            return renderAssign(row);
                          case 'assignedBy':
                            return <span>{row.assignedBy?.name ?? 'N/A'}</span>;
                          case 'assignees':
                            return (
                              <span>
                                {Array.isArray(row.users) && row.users.length > 0
                                  ? row.users.map((user) => user.name).join(', ')

                                  : 'N/A'}
                              </span>
                            );
                          case 'user.name':
                            return (<span>{row.user?.name ?? 'N/A'}</span>);
                          case 'tags':
                            return <span>{renderTags(row[column.accessor])}</span>;
                          case 'status':
                            return renderStatus(row);
                          case 'department.name':
                            return <span>{row.department?.name ?? 'N/A'}</span>;
                          case 'category.name':
                            return <span>{row.category?.name ?? 'N/A'}</span>;
                          case 'product':
                            return <span>{row.product?.name ?? 'N/A'}</span>;
                          case 'activity':
                            return <span>{row.action ?? 'N/A'}</span>;
                          case 'in_stock':
                            return <span>{row.in_stock ? 'Available' : 'Out of Stock'}</span>;
                          case 'is_verified':
                            return <span>{row.is_verified ? 'Yes' : 'No'}</span>;
                          default:
                            return column.Cell
                              ? column.Cell(row)
                              : getCellValue(row, column.accessor);
                        }
                      })()}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CommonTable;
